import React from "react";

// Iter60.p59 — Shared employment-status badge. Same visual language
// used on Staff, StaffProfile, Attendance, and the bulk-change dialog
// so a "Terminated" chip looks identical everywhere.
//
// Taxonomy locked from user spec (8 lifecycle states):
//   active               → green
//   undeployed           → neutral gray
//   project_completed    → amber
//   contract_ended       → amber
//   resigned             → neutral blue
//   terminated           → red
//   retired              → purple
//   on_leave_extended    → cyan
export const EMPLOYMENT_STATUSES = [
    "active",
    "undeployed",
    "project_completed",
    "contract_ended",
    "resigned",
    "terminated",
    "retired",
    "on_leave_extended",
];

export const EMPLOYMENT_STATUS_LABEL = {
    active: "Active",
    undeployed: "Undeployed",
    project_completed: "Project Completed",
    contract_ended: "Contract Ended",
    resigned: "Resigned",
    terminated: "Terminated",
    retired: "Retired",
    on_leave_extended: "On Leave (Extended)",
};

const TONES = {
    active: { bg: "#ECFDF5", fg: "#065F46", border: "#A7F3D0" },
    undeployed: { bg: "#F3F4F6", fg: "#374151", border: "#D1D5DB" },
    project_completed: { bg: "#FFFBEB", fg: "#92400E", border: "#FDE68A" },
    contract_ended: { bg: "#FFFBEB", fg: "#92400E", border: "#FDE68A" },
    resigned: { bg: "#EFF6FF", fg: "#1E3A8A", border: "#BFDBFE" },
    terminated: { bg: "#FEF2F2", fg: "#991B1B", border: "#FECACA" },
    retired: { bg: "#F5F3FF", fg: "#5B21B6", border: "#DDD6FE" },
    on_leave_extended: { bg: "#ECFEFF", fg: "#155E75", border: "#A5F3FC" },
};

export default function EmploymentStatusBadge({ status, testid, size = "sm" }) {
    const s = (status || "active").toLowerCase();
    const tone = TONES[s] || { bg: "#F5F6F8", fg: "#1A1A1A", border: "#E5E7EB" };
    const label = EMPLOYMENT_STATUS_LABEL[s] || status || "Active";
    const px = size === "xs" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]";
    return (
        <span
            data-testid={testid || "employment-status-badge"}
            data-status={s}
            className={`inline-flex items-center rounded-full font-semibold whitespace-nowrap ${px}`}
            style={{ background: tone.bg, color: tone.fg, border: `1px solid ${tone.border}` }}
        >
            {label}
        </span>
    );
}
